import { t } from 'ember-intl';
import Component from '@glimmer/component';
import pageTitle from 'ember-page-title/helpers/page-title';
import type PslfEmployerController from 'tio-employee/controllers/pslf-employer';

interface S {
  Args: {
    model: {
      pathToken: string;
    };
    controller: PslfEmployerController;
  };
}

export default class PslfEmployerPage extends Component<S> {
  <template>
    {{pageTitle (t "pslf.employer_sign_page_title")}}

    <div class="tio-col-flush h-screen container mx-auto">
      {{outlet}}
    </div>
  </template>
}
